/* Lux UGC mobile carousel auto-advance.
   Desktop keeps the CSS marquee (untouched). On mobile (<750px) the CSS turns
   the grid into a horizontal scroll-snap rail showing 2 tiles; this script
   gently auto-advances it and pauses while the user is interacting. */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';
  var INTERVAL = 3500; // ms between advances

  function initGrid(grid) {
    if (grid.dataset.luxUgcCarousel === 'true') return;
    grid.dataset.luxUgcCarousel = 'true';

    var timer = null;
    var paused = false;

    function tileStep() {
      var tile = grid.querySelector('.lux-ugc__tile');
      if (!tile) return grid.clientWidth * 0.5;
      var style = getComputedStyle(grid);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      // advance by two tiles (a full view)
      return (tile.getBoundingClientRect().width + gap) * 2;
    }

    function advance() {
      if (paused) return;
      var maxScroll = grid.scrollWidth - grid.clientWidth - 2;
      if (grid.scrollLeft >= maxScroll) {
        grid.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        grid.scrollBy({ left: tileStep(), behavior: 'smooth' });
      }
    }

    function start() {
      stop();
      timer = setInterval(advance, INTERVAL);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    // Pause on user interaction, resume shortly after
    var resumeTimer = null;
    function userInteracted() {
      paused = true;
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; }, 4000);
    }
    grid.addEventListener('touchstart', userInteracted, { passive: true });
    grid.addEventListener('pointerdown', userInteracted, { passive: true });
    grid.addEventListener('wheel', userInteracted, { passive: true });

    grid._luxStart = start;
    grid._luxStop = stop;
    start();
  }

  function teardownGrid(grid) {
    if (grid.dataset.luxUgcCarousel !== 'true') return;
    if (grid._luxStop) grid._luxStop();
    grid.dataset.luxUgcCarousel = 'false';
  }

  function apply() {
    var isMobile = window.matchMedia(MOBILE).matches;
    var grids = document.querySelectorAll('.lux-ugc__grid');
    grids.forEach(function (grid) {
      if (isMobile) initGrid(grid);
      else teardownGrid(grid);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
  window.matchMedia(MOBILE).addEventListener('change', apply);

  // Re-init after Theme Editor reloads the section
  document.addEventListener('shopify:section:load', apply);
})();